/**
 * Shared navigation model — drives the desktop mega-menu / dropdowns, the
 * mobile sheet and the footer so all three stay in sync.
 * Every `to` maps to an existing route.
 */
import {
  Smile, Scissors, Sparkles, Flower2, Baby, Eye, HeartPulse, Bone,
} from 'lucide-react';

export const TREATMENT_SERVICES = [
  { label: 'Dental',                     to: '/dental-treatments-in-vietnam',          desc: 'Implants, veneers & full-mouth care',       icon: Smile },
  { label: 'Cosmetic & Plastic Surgery', to: '/cosmetic-surgery-in-vietnam',           desc: 'Face, breast & body procedures',            icon: Scissors },
  { label: 'Hair Restoration',           to: '/hair-restoration-in-vietnam',           desc: 'FUE transplants & PRP support',             icon: Sparkles },
  { label: 'Aesthetic & Beauty',         to: '/aesthetic-skin-treatments-in-vietnam',  desc: 'Skin, injectables & non-surgical',          icon: Flower2 },
  { label: 'Fertility',                  to: '/fertility-treatments-in-vietnam',       desc: 'IVF, IUI & fertility assessment',           icon: Baby },
  { label: 'Eye Care',                   to: '/eye-care-treatments-in-vietnam',        desc: 'LASIK, cataract & eye health',              icon: Eye },
  {
    label: 'Health Check-Ups',
    to: '/health-checkup-packages-vietnam',
    desc: 'Standard to VIP screening packages',
    icon: HeartPulse,
    children: [
      { label: 'Standard',      to: '/health-checkup-packages-vietnam#standard' },
      { label: 'Comprehensive', to: '/health-checkup-packages-vietnam#comprehensive' },
      { label: 'Advanced',      to: '/health-checkup-packages-vietnam#advanced' },
      { label: 'Premium',       to: '/health-checkup-packages-vietnam#premium' },
      { label: 'VIP',           to: '/health-checkup-packages-vietnam#vip' },
    ],
  },
  { label: 'Orthopedics',                to: '/orthopedic-treatments-in-vietnam',      desc: 'Joint, spine & sports injuries',            icon: Bone },
];

export const PATIENT_SUPPORT = [
  { label: 'Doctor Recommendations',        to: '/doctor-recommendation-vietnam' },
  { label: 'Medical Translator',            to: '/medical-translator-vietnam' },
  { label: 'Medical Tourism Support',       to: '/medical-tourism-support-vietnam' },
  { label: 'Airport / Hospital Assistance', to: '/travel-hub/transport' },
  { label: 'Aftercare',                     to: '/care-after-discharge-vietnam' },
];

export const FOR_CLINICS = [
  { label: 'Register Your Clinic', to: '/clinic-registration' },
  { label: 'Partner Information',  to: '/pricing' },
  { label: 'How It Works',         to: '/how-it-works#for-clinics' },
  { label: 'Clinic FAQ',           to: '/faq' },
  { label: 'Company Details',      to: '/company-details' },
];

// Urgent-care dropdown — all routes already exist; no new pages / URLs.
export const URGENT_CARE_SERVICES = [
  { label: 'Doctor-to-Hotel Visits',       to: '/doctor-to-hotel-vietnam' },
  { label: 'English-Speaking Doctors',     to: '/english-speaking-doctor-vietnam' },
  { label: 'Common Illnesses in Vietnam',  to: '/common-illnesses-vietnam' },
];

export const URGENT_CARE_LOCATIONS = [
  { label: 'Da Nang & Hoi An', to: '/urgent-medical-care-hoi-an' },
  { label: 'Ho Chi Minh City', to: '/urgent-medical-care-ho-chi-minh' },
  { label: 'Hanoi',            to: '/urgent-medical-care-hanoi' },
  { label: 'Nha Trang',        to: '/urgent-medical-care-nha-trang' },
  { label: 'Phu Quoc',         to: '/urgent-medical-care-phu-quoc' },
  { label: 'Sapa (Sa Pa)',     to: '/urgent-medical-care-sapa' },
];

// Flat structure for the mobile accordion: overview + services + Locations group.
export const URGENT_CARE_MOBILE = [
  { label: 'Urgent Care overview', to: '/urgent-medical-care' },
  ...URGENT_CARE_SERVICES,
  { label: 'Locations', to: '/urgent-medical-care', children: URGENT_CARE_LOCATIONS },
];
